"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listLoginIdentityCompanies = void 0;
const api_error_1 = require("./errors/api_error");
function listLoginIdentityCompanies({ loginIdentityId, globalDomain, token, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const globalApiUrl = `https://global-api.${globalDomain}/v1`;
        const response = yield fetch(`${globalApiUrl}/login-identities/${loginIdentityId}/companies`, {
            headers: {
                authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new api_error_1.APIError(`Could not fetch companies for loginIdentityId: '${loginIdentityId}'`, response);
        }
        try {
            const data = (yield response.json());
            return {
                companies: data.companies.map(company => ({
                    companyCode: company.company_code,
                    regionCode: company.region_code,
                    companyName: company.company_name,
                    companyLogoUrl: company.company_logo_url,
                    switchWorkspacesEnabled: company.switch_workspaces_enabled,
                })),
                nextPageToken: data.next_page_token,
                totalSize: data.total_size,
            };
        }
        catch (error) {
            throw new api_error_1.APIError(`Error fetching companies for loginIdentityId: '${loginIdentityId}'`, response);
        }
    });
}
exports.listLoginIdentityCompanies = listLoginIdentityCompanies;
//# sourceMappingURL=list_login_identity_companies.js.map